import { gql } from "@apollo/client";

export const CREATE_SUPPORTER = gql`
  mutation createSupporter(
    $entityNumber: Int
    $entityForm: String!
    $name: String!
    $nameKana: String!
    $representativeName: String!
    $incorporationDate: Date!
    $prefecture: String!
    $city: String!
    $phoneNumber: String!
    $industry: String!
    $mission: String
    $sustainabilityPolicy: String
    $collaborationExperienceTime: String
    $collaborationNeeds: [ID]
    $focusedSdges: [ID]
    $focusedStakeholders: [ID]
    $interestingActivity: [ID]
    $interestingCountry: [ID]
  ) {
    createSupporter(
      input: {
        entityNumber: $entityNumber
        entityForm: $entityForm
        name: $name
        nameKana: $nameKana
        representativeName: $representativeName
        incorporationDate: $incorporationDate
        prefecture: $prefecture
        city: $city
        phoneNumber: $phoneNumber
        industry: $industry
        mission: $mission
        sustainabilityPolicy: $sustainabilityPolicy
        collaborationExperienceTime: $collaborationExperienceTime
        collaborationNeeds: $collaborationNeeds
        focusedSdges: $focusedSdges
        focusedStakeholders: $focusedStakeholders
        interestingActivity: $interestingActivity
        interestingCountry: $interestingCountry
      }
    ) {
      supporter {
        id
        name
        collaborationExperienceTime
        entityNumber
        entityForm
        nameKana
        representativeName
        incorporationDate
        prefecture
        city
        phoneNumber
        industry
        mission
        sustainabilityPolicy
        collaborationExperienceTime
        collaborationNeeds {
          edges {
            node {
              title
            }
          }
        }
        focusedSdges {
          edges {
            node {
              id
              title
            }
          }
        }
        focusedStakeholders {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_SUPPORTER = gql`
  mutation questionnaire_update_supporera(
    $mission: String
    $sustainabilityPolicy: String
    $collaborationExperienceTime: String
    $collaborationNeeds: [ID]
    $focusedSdges: [ID]
    $focusedStakeholders: [ID]
    $interestingActivity: [ID]
    $interestingCountry: [ID]
  ) {
    questionnaireUpdateSupporter(
      input: {
        mission: $mission
        sustainabilityPolicy: $sustainabilityPolicy
        collaborationExperienceTime: $collaborationExperienceTime
        collaborationNeeds: $collaborationNeeds
        focusedSdges: $focusedSdges
        focusedStakeholders: $focusedStakeholders
        interestingActivity: $interestingActivity
        interestingCountry: $interestingCountry
      }
    ) {
      supporter {
        name
        mission
        sustainabilityPolicy
        collaborationExperienceTime
        focusedSdges {
          edges {
            node {
              title
            }
          }
        }
        collaborationNeeds {
          edges {
            node {
              title
            }
          }
        }
        interestingCountry {
          edges {
            node {
              nameJp
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_CSO_PREFERENCE = gql`
  mutation questionnaire_update_cso(
    $collaborationExperienceTime: String
    $collaborationNeeds: [ID]
  ) {
    questionnaireUpdateCso(
      input: {
        collaborationExperienceTime: $collaborationExperienceTime
        csocollaborationneeds: $collaborationNeeds
      }
    ) {
      cso {
        name
        purpose
        csocollaborationneeds {
          collaborationNeeds {
            edges {
              node {
                id
                title
              }
            }
          }
        }
      }
    }
  }
`;

export const FETCH_LEGAL_ENTITY = gql`
  mutation houjin($legalEntityNumber: String!) {
    fetchLegalEntityInfo(input:{legalEntityNumber: $legalEntityNumber}){
      legalEntityInfo
    }
  }
`